/**
 * `clawnify env` — the org's custom environment variables, injected into every
 * agent's gateway. Reading is `clawnify connections list` (the customEnv
 * section); this sets/unsets. Org-scoped; setting or removing one restarts the
 * gateway to apply, so agents briefly reconnect.
 *
 * NOT for secrets: don't pass a real API key / secret here from an agent — it
 * exposes the value in the command line and the agent's context. Secrets belong
 * in the dashboard (Settings → Environment Variables / API Keys). Use this only
 * for non-secret config (a flag, a default, a public URL).
 */

import { api } from "../lib/api.js";

export async function envSetCommand(key: string, value: string): Promise<void> {
  const res = await api.post("/settings/custom-keys", { key_name: key, key_value: value });
  const data = (await res.json().catch(() => ({}))) as { error?: string };
  if (!res.ok) {
    console.error(`Failed to set ${key} (${res.status})${data.error ? `: ${data.error}` : ""}.`);
    process.exit(1);
  }
  console.log(`Set ${key} org-wide. The gateway restarts to apply — agents briefly reconnect.`);
}

export async function envUnsetCommand(key: string): Promise<void> {
  const res = await api.del(`/settings/custom-keys/${encodeURIComponent(key)}`);
  if (!res.ok) {
    const data = (await res.json().catch(() => ({}))) as { error?: string };
    console.error(`Failed to unset ${key} (${res.status})${data.error ? `: ${data.error}` : ""}.`);
    process.exit(1);
  }
  console.log(`Removed ${key} org-wide. The gateway restarts to apply.`);
}
